import { LockOutlined, LogoutOutlined } from "@ant-design/icons";
import { Divider, Form, Input, Menu, Modal } from "antd";
import { redirect, useNavigate } from "react-router-dom";
import RoutePath from "../../app/routing/routes.path";
import { LogoutUser } from "./homeThunk";
import { useAppDispatch } from "../../app/hooks";
import { useState } from "react";

export default function AvatarMenu() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const pwdModalState = useState(false);
    const [_, showPwdModal] = pwdModalState;

    const items = [
        {
            key: "changePwd",
            icon: (<LockOutlined />),
            label: "Change Password",
            onClick: async ()=>{
                showPwdModal(true);
            }
        },
        {
            key: "logOut",
            icon: (<LogoutOutlined />),
            label: "Log Out",
            onClick: async ()=>{
                await dispatch(LogoutUser());
                localStorage.clear();
                return navigate(RoutePath.login);
            }
        }
    ]
    return (<>
        <Menu items={items} selectedKeys={[]}></Menu>
        <ChangePasswordModal 
            modalState={pwdModalState}
        />
    </>)
}

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
type ChangePasswordModalPropType = {
    modalState: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
}
function ChangePasswordModal(props: ChangePasswordModalPropType) {
    const [pwdModal, showPwdModal] = props.modalState;
    const [formRef] = Form.useForm();
    return (<Modal
        title="Change Password"
        open={pwdModal}
        okText="Update"
        onCancel={() => showPwdModal(false)}
        maskClosable={false}
    >
        <Form
            {...layout}
            form={formRef}
        >
            <Form.Item
                name="oldPwd"
                label="Old Password"
                validateDebounce={1000}
                rules={[
                    { required: true }
                ]}
            >
                <Input.Password />
            </Form.Item>
            <Divider />
            <Form.Item
                name="newPwd"
                label="New Password"
                validateDebounce={1000}
                rules={[
                    { required: true },
                    { min: 8 },
                    {
                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]*$/,
                        message: "Must contain UPPERCASE, lowercase, digit & special symbol (@$!%*?&)"
                    }
                ]}
            >
                <Input.Password />
            </Form.Item>
            <Form.Item
                name="verifyPwd"
                label="Verify Password"
                dependencies={['newPwd']}
                rules={[
                    { required: true },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('newPwd') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error('The new password that you entered do not match!'));
                        },
                    })
                ]}
            >
                <Input.Password />
            </Form.Item>
        </Form>
    </Modal>)
}